import { makeAutoObservable, runInAction } from "mobx";
import http from "../services/http";
import appConfigStore from "./appConfigStore";
import companyFeatureStore from "./companyFeaturesStore";
import featurePriceStore from "./featurePricesStore";
import licensesStore from "./licensesStore";

export type PaymentMethod = "card" | "foreign_card" | "sbp" | "tinkoff_pay" | "sberpay";

class PaymentCheckoutStore {
  open = false;
  loading = false;
  error = "";
  payment: any = null;
  options: any = null;

  constructor() { makeAutoObservable(this); }

  show(options: any) { this.options = options; this.open = true; this.error = ""; this.payment = null; }
  close() {
    const url = new URL(window.location.href);
    if (url.searchParams.has("paymentId")) {
      url.searchParams.delete("paymentId");
      window.history.replaceState(window.history.state, "", url.toString());
    }
    this.open = false; this.payment = null;
  }

  setPayment(payment: any) {
    this.payment = { ...payment, nextAction: payment.status === "failed" && ["card", "foreign_card"].includes(payment.method) ? { type: "card_cryptogram" } : payment.nextAction };
  }

  async refreshPurchases() {
    const id = this.payment?.id;
    const results = await Promise.allSettled([
      appConfigStore.onRefreshConfig(),
      this.payment?.returnPath === "/" ? licensesStore.findAll() : companyFeatureStore.fetchActive(),
      featurePriceStore.fetchAll(),
    ]);
    if (results.some((result) => result.status === "rejected")) {
      runInAction(() => {
        if (this.payment?.id === id) {
          this.error = "Оплата прошла успешно, но не удалось обновить данные покупки. Обновите страницу, чтобы увидеть изменения.";
        }
      });
    }
  }

  async refreshPayment(id: string) {
    const response = await http.get(`/payment-intents/${id}`);
    runInAction(() => {
      if (this.payment?.id === id) {
        const payment = response.data.data;
        const action = payment.status === "failed" && ["card", "foreign_card"].includes(payment.method)
          ? { type: "card_cryptogram" } : this.payment.nextAction;
        this.payment = { ...payment, nextAction: action };
      }
    });
  }

  async resume(id: string) {
    try {
      const response = await http.get(`/payment-intents/${id}`);
      runInAction(() => {
        this.setPayment(response.data.data);
        this.options = null; this.open = true; this.error = "";
      });
    } catch (error: any) {
      runInAction(() => {
        this.open = true; this.options = null; this.payment = null;
        this.error = error?.response?.status === 404 ? "Платёж не найден или недоступен для вашего аккаунта." : "Не удалось получить результат оплаты. Обновите страницу, чтобы проверить статус.";
      });
    }
  }

  async create(termMonths: number, method: PaymentMethod, recurring: boolean, phone?: string, clientContext?: Record<string, unknown>) {
    this.loading = true; this.error = "";
    try {
      const response = await http.post("/payment-intents", {
        ...(this.options.kind === "tariff" ? { tariffId: this.options.id } : { featurePriceId: this.options.id }),
        quantity: this.options.quantity || 1, termMonths, method, recurring,
        ...(method === "sberpay" ? { phone } : {}),
        ...clientContext,
      });
      runInAction(() => { this.payment = response.data.data; });
      return response.data.data;
    } catch (error: any) {
      runInAction(() => { this.error = error?.response?.data?.message || "Не удалось создать оплату"; });
      throw error;
    } finally { runInAction(() => { this.loading = false; }); }
  }
}

const paymentCheckoutStore = new PaymentCheckoutStore();
export default paymentCheckoutStore;
